<template>
    <div class="bg-amber-400 text-gray-700 p-4 grid grid-cols-[min-content_1fr_min-content] gap-4 items-center">
        <PriorityHighIcon class="w-14 h-14" />
        <div>
            <h2 class="font-semibold text-xl">{{ $t('update-available') }}</h2>
            <p>{{ $t('update-available-details') }}</p>
        </div>

        <Button size="Base" variant="Neutral-Strong" @click="$emit('click')">
            <template #icon>
                <RefreshIcon class="size-5" />
            </template>
            {{ $t('reload-page') }}
        </Button>
    </div>
</template>

<script setup lang="ts">
import Button from '../Button/Button.vue';
import PriorityHighIcon from '../Icon/PriorityHighIcon.vue';
import RefreshIcon from '../Icon/RefreshIcon.vue';

defineEmits<{ (e: 'click'): void }>();
</script>
